import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { getPaypalConfig, createPaypalOrder, capturePaypalOrder } from "@/lib/api";

export default function PayPalDonate({ getDonation, disabled, forceKey }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    getPaypalConfig().then(setConfig).catch(() => setConfig({ enabled: false }));
  }, []);

  if (!config || !config.enabled) return null;

  return (
    <div data-testid="paypal-donate">
      <div className="flex items-center gap-3 my-1">
        <div className="h-px bg-plum/10 flex-1" />
        <span className="text-xs text-stone uppercase tracking-wider">or give with</span>
        <div className="h-px bg-plum/10 flex-1" />
      </div>
      {disabled && (
        <p className="text-xs text-stone text-center mb-2">Add your name, email, and amount above to pay with PayPal.</p>
      )}
      <PayPalScriptProvider options={{ clientId: config.client_id, currency: "USD", intent: "capture" }}>
        <PayPalButtons
          disabled={disabled}
          forceReRender={[forceKey]}
          style={{ layout: "horizontal", color: "gold", shape: "pill", height: 45, tagline: false }}
          createOrder={async () => {
            const d = getDonation();
            if (!d) return Promise.reject(new Error("invalid"));
            const res = await createPaypalOrder(d);
            return res.order_id;
          }}
          onApprove={async (data) => {
            try {
              const res = await capturePaypalOrder(data.orderID);
              if (res.status === "paid") {
                window.location.href = `${window.location.origin}/payment/success?session_id=${data.orderID}`;
              } else {
                toast.error("Payment not completed. Please try again.");
              }
            } catch {
              toast.error("We couldn't confirm your PayPal payment. If you were charged, please contact us.");
            }
          }}
          onError={() => toast.error("PayPal ran into a problem. Please try again or use the card option.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
